import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";

export default {
    name: "dictionaryManagement",
    components: { iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            searchValue: '',
            brandId: '',
            brandName: '',
            projectDescribe: '',
            BrandList: [],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "projectName",
                    label: this.$t('VehicleManagement.entryName'),
                    align: "center",
                },
                // {
                //     prop: "remarks",
                //     label: this.$t('common.remark'),
                //     align: "center",
                // },
                {
                    prop: "projectDescribe",
                    label: this.$t('VehicleManagement.projectDescription'),
                    align: "center",
                },
                {
                    prop: "createTime",
                    label: this.$t('common.setUpTime'),
                    align: "center",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.createTime))
                    // }
                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            diaBtn: '',
            rules: {},
            form: {
                name: '',
                projectDescribe: '',
                brandSort: ''
            },
            // dialogModelFormVisible: false,
            // diaModelTitle: '',
            // btnModel: '',
            // ModelRules: {},
            // ModelForm: {
            //     name: '',
            //     remarks: '',
            // },
            selected: [],
            id: '',
            brandSort: ''
        }
    },
    created() {
        this.getBrand()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getBrand() {
            this.$store.dispatch('MaintenanceProgram/GET_SELECTMAINTAINPROJECT', {
                projectName: this.searchValue
            }).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.BrandList = res.data.data.list
                        this.brandId = res.data.data.list[0].id
                        this.brandName = res.data.data.list[0].projectName
                        this.brandSort = res.data.data.list[0].maintainIndex
                        this.projectDescribe = res.data.data.list[0].projectDescribe
                        this.getModel()
                    }
                }
            }).catch(err => { })
        },
        getModel() {
            let param = {
                superiorId: this.brandId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('MaintenanceProgram/GET_SELECTMAINTAINPROJECT', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        ChangModel(val) {
            console.log(val)
            this.brandId = val
            let value = this.BrandList.find((item) => item.id == val);
            this.brandName = value.projectName
            this.brandSort = value.maintainIndex
            this.projectDescribe = value.projectDescribe
            this.getModel()
        },
        addBrand() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('VehicleManagement.newProject')
            this.diaBtn = 'add'
        },
        editBrand() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('VehicleManagement.modifyProject')
            this.diaBtn = 'edit'
            this.form.name = this.brandName
            this.form.brandSort = this.brandSort
            this.form.projectDescribe = this.projectDescribe
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        projectName: this.form.name,
                        projectDescribe: this.form.projectDescribe,
                        maintainIndex: this.form.brandSort,
                    }
                    if (this.diaBtn == 'add') {
                        this.$store.dispatch('MaintenanceProgram/GET_INSERTMAINTAINPROJECT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('VehicleManagement.newProjectSuccessfully'))
                                this.dialogFormVisible = false;
                                this.getBrand();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    } else if (this.diaBtn == 'edit') {
                        param.id = this.brandId
                        this.$store.dispatch('MaintenanceProgram/GET_UPDATEMAINTAINPROJECT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('VehicleManagement.projectModificationSuccessful'))
                                this.dialogFormVisible = false;
                                this.getBrand();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    } else if (this.diaBtn == 'proAdd') {
                        param.superiorId = this.brandId
                        this.$store.dispatch('MaintenanceProgram/GET_INSERTMAINTAINPROJECT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('VehicleManagement.projectModificationSuccessful'))
                                this.dialogFormVisible = false;
                                this.getModel();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    } else {
                        param.id = this.selected[0].id
                        this.$store.dispatch('MaintenanceProgram/GET_UPDATEMAINTAINPROJECT', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('VehicleManagement.projectModificationSuccessful'))
                                this.dialogFormVisible = false;
                                this.getModel();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    }
                } else {
                    return false;
                }
            });
        },
        addModel() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.diaBtn = 'proAdd'
        },
        editModel() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.diaBtn = 'proEdit'
            this.form.name = this.selected[0].projectName
            this.form.brandSort = this.selected[0].maintainIndex
            this.form.projectDescribe = this.selected[0].projectDescribe
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                name: '',
                brandSort: '',
                projectDescribe: ''
            }
        },
        closeDia() {
            this.form = {
                name: '',
                brandSort: '',
                projectDescribe: ''
            }
            this.dialogFormVisible = false;
        },
        deleteBrand() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.brandId }
                    this.$store.dispatch('MaintenanceProgram/GET_DELETEMAINTAINPROJECT', param).then(response => {
                        if (response.data.code == 200) {
                            this.getBrand()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },

        // submitModelForm(ModelFormName) {
        //     this.$refs[ModelFormName].validate((valid) => {
        //         if (valid) {
        //             let param = {
        //                 brandId: this.brandId,
        //                 name: this.ModelForm.name,
        //                 remarks: this.ModelForm.remarks,
        //             }
        //             if (this.btnModel == 'add') {
        //                 this.$store.dispatch('dictionaryManagement/GET_INSERTBRANDTYPE', param).then(res => {
        //                     if (res.data.code == 200) {
        //                         this.$message.success(this.$t('PlatformSettings.form.addTypeSuccess'))
        //                         this.dialogModelFormVisible = false;
        //                         this.getModel();
        //                         this.closeModelDia();
        //                     } else {
        //                         this.$message.error(res.data.msg)
        //                     }

        //                 }).catch(err => { })
        //             } else {
        //                 param.id = this.selected[0].id
        //                 this.$store.dispatch('dictionaryManagement/GET_UPDATEBRANDTYPE', param).then(res => {
        //                     if (res.data.code == 200) {
        //                         this.$message.success(this.$t('PlatformSettings.form.editTypeSuccess'))
        //                         this.dialogModelFormVisible = false;
        //                         this.getModel();
        //                         this.closeModelDia();
        //                     } else {
        //                         this.$message.error(res.data.msg)
        //                     }

        //                 }).catch(err => { })
        //             }


        //         } else {
        //             return false;
        //         }
        //     });
        // },
        // cancleModel(ModelFormName) {
        //     this.dialogModelFormVisible = false;
        //     this.ModelForm = {
        //         name: '',
        //         remarks: ''
        //     }
        // },
        // closeModelDia() {
        //     this.ModelForm = {
        //         name: '',
        //         remarks: ''
        //     }
        //     this.dialogModelFormVisible = false;
        // },
        deleteModel() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.selected[0].id }
                    this.$store.dispatch('MaintenanceProgram/GET_DELETEMAINTAINPROJECT', param).then(response => {
                        if (response.data.code == 200) {
                            this.getModel()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getModel();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}